import { Button } from "@/components/ui/button";
import {
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import type { KnowledgeBaseQuestion } from "@/types/knowledgeBase";
import { useEffect, useState } from "react";

interface QuestionFormProps {
  type: "add" | "edit";
  question: KnowledgeBaseQuestion;
  onSave: (question: KnowledgeBaseQuestion) => void;
  onCancel: () => void;
}

export default function QuestionForm({
  type,
  question: initialQuestion,
  onSave,
  onCancel,
}: QuestionFormProps) {
  const [question, setQuestion] =
    useState<KnowledgeBaseQuestion>(initialQuestion);

  useEffect(() => {
    setQuestion(initialQuestion);
  }, [initialQuestion]);

  const isValid =
    question.question.trim() !== "" && question.answer.trim() !== "";
  const title = type === "add" ? "Adicionar Pergunta" : "Editar Pergunta";
  const description =
    type === "add"
      ? "Adicione uma nova pergunta à base de conhecimento"
      : "Modifique as informações desta pergunta";
  const actionText = type === "add" ? "Adicionar" : "Salvar";

  const handleSave = () => {

    if (isValid) {
      onSave(question);
    }
  };

  return (
    <DrawerContent>
      <DrawerHeader>
        <DrawerTitle>{title}</DrawerTitle>
        <DrawerDescription>{description}</DrawerDescription>
      </DrawerHeader>
      <div className="px-4 py-2">
        <div className="grid gap-4">
          <div className="grid gap-2">
            <Label htmlFor="question">Pergunta</Label>
            <Input
              id="question"
              value={question.question}
              onChange={(e) =>
                setQuestion({
                  ...question,
                  question: e.target.value,
                })
              }
              placeholder="Ex: Como alterar minha senha?"
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="answer">Resposta</Label>
            <Textarea
              id="answer"
              value={question.answer}
              onChange={(e) =>
                setQuestion({
                  ...question,
                  answer: e.target.value,
                })
              }
              placeholder="Digite a resposta detalhada para a pergunta"
              rows={4}
            />
          </div>
          <div className="flex items-center space-x-2">
            <Switch
              id="active"
              checked={question.isActive}
              onCheckedChange={(checked) =>
                setQuestion({
                  ...question,
                  isActive: checked,
                })
              }
            />
            <Label htmlFor="active">Ativo</Label>
          </div>
        </div>
      </div>
      <DrawerFooter>
        <Button onClick={handleSave} disabled={!isValid}>
          {actionText}
        </Button>
        <Button variant="outline" onClick={onCancel}>
          Cancelar
        </Button>
      </DrawerFooter>
    </DrawerContent>
  );
}
